// MobileTopNavbar.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import logo from "assets/logo.png";

const MobileTopNavbar = ({ user, onOpenMenu }) => {
  return (
    <div className="md:hidden sticky top-0 z-30 w-full flex items-center justify-between gap-3 px-4 py-3 bg-white/90 backdrop-blur-md shadow-sm">
      <button
        onClick={onOpenMenu}
        aria-label="Ouvrir le menu"
        className="w-10 h-10 -ml-1 flex items-center justify-center rounded-full text-[#221C51] active:bg-gray-100 transition"
      >
        <FontAwesomeIcon icon={faBars} className="text-lg" />
      </button>

      <img src={logo} alt="OnebotAds" className="h-6" />

      <button
        onClick={onOpenMenu}
        aria-label="Profil"
        className="w-10 h-10 flex items-center justify-center rounded-full active:bg-gray-100 transition"
      >
        <FontAwesomeIcon icon={faUserCircle} className="text-2xl text-[#221C51]" />
      </button>
    </div>
  );
};

export default MobileTopNavbar;
